import request from "@/utils/request";
//平台端查询产品线列表
export function plProductBagsPlatformPage(data) {
  return request({
    url: `/sales-rule/pl/plProductBags/platformPage`,
    method: "get",
    params: data,
  });
}

// /pl/plProductBags/{id}
// 查询产品线详情
export function plProductBagsIdGet(params) {
  return request({
    url: `/sales-rule/pl/plProductBags/${params.id}`,
    method: "get",
    params: params,
  });
}

// 平台端查询销售分类列表
export function plSaleCategorys(data) {
  return request({
    url: `/sales-rule/pl/plSaleCategorys`,
    method: "get",
    params: data,
  });
}
// 平台端销售分类新增
export function plSaleCategoryAdd(data) {
  return request({
    url: `/sales-rule/pl/plSaleCategorys`,
    method: "post",
    data,
  });
}
// 平台端销售分类编辑
export function plSaleCategoryEdit(data) {
  return request({
    url: `/sales-rule/pl/plSaleCategorys/${data.id}`,
    method: "put",
    data,
  });
}
// 平台端销售分类删除
export function plSaleCategoryDelete(id) {
  return request({
    url: `/sales-rule/pl/plSaleCategorys/${id}`,
    method: "delete",
  });
}
// 平台端销售规则排序交换

export function plSaleCategorysExchange(data) {
  return request({
    url: `/sales-rule/pl/plSaleCategorys/exchange`,
    method: "post",
    data,
  });
}
// 平台端销售规则置顶
export function plSaleCategorysTop(id) {
  return request({
    url: `/sales-rule/pl/plSaleCategorys/top/${id}`,
    method: "patch",
  });
}
// 平台端销售规则置底
export function plSaleCategorysBottom(id) {
  return request({
    url: `/sales-rule/pl/plSaleCategorys/tail/${id}`,
    method: "patch",
  });
}

// ************ 服务费率规则 **********

// 平台端查询服务费率规则列表
export function plServiceChargeRules(data) {
  return request({
    url: `/sales-rule/pl/plProductBagFeeConfigs/listRuleFeeConfig/${data.shopId}`,
    method: "get",
  });
}
// 平台端服务费率保存
export function plProductBagFeeConfigsSaveFeeConfigList(data) {
  return request({
    url: `/sales-rule/pl/plProductBagFeeConfigs/saveFeeConfigList`,
    method: "post",
    data,
  });
}

// 平台端 销售产品线-审核通过
export function plProductBagsAuditPass(data) {
  return request({
    url: "/sales-rule/pl/plProductBags/audit/pass",
    method: "put",
    data,
  });
}

// 平台端 销售产品线-审核驳回
export function plProductBagsAuditReject(data) {
  return request({
    url: "/sales-rule/pl/plProductBags/audit/reject",
    method: "put",
    data,
  });
}

// /pl/plProductBags/{id}
// 修改产品线
export function plProductBagsIdPut(data) {
  return request({
    url: `/sales-rule/pl/plProductBags/${data.id}`,
    method: "put",
    data: data,
  });
}

// /pl/plProductBags/platform/auditCount
// 平台端 销售产品线-待审核数量    平台端查询产品线申请总数
export function plProductBagsPlatformAuditCount(data) {
  return request({
    url: "/sales-rule/pl/plProductBags/platform/auditCount",
    method: "get",
    params: data,
  });
}
// 查询分账规则
export function teamUsedRuleSys(id) {
  return request({
    url: `/sales-rule/ss/ssBagAdPlans/teamUsedRuleSys/${id}`,
    method: "post",
  });
}

// 平台端 查询控销商品列表
export function plDkxGoodsPage(data) {
  return request({
    url: "/statistic/dkx/goods/page",
    method: "get",
    params: data,
  });
}
// 根据 adplanId 查询组织结构
export function queryOrgStructureByAdplanId(adplanId) {
  return request({
    url: `/sales-rule/ss/ssBagAdPlans/planTeamTreeForSys/${adplanId}`,
    method: "post",
  });
}
// 根据 tree 查询 teamList
export function ssAdTeamMembers(data) {
  return request({
    url: `/sales-rule/ss/ssAdTeamMembers`,
    method: "get",
    params: data,
  });
}
// 平台端 查看待分配买家
export function ssAdTeamAreasGetWaitClinic(data) {
  return request({
    url: "/sales-rule/ss/ssAdTeamAreas/getWaitClinic",
    method: "get",
    params: data,
  });
}
// 平台端 查看已分配买家
export function ssAdTeamAreasGetAllocatedClinic(data) {
  return request({
    url: "/sales-rule/ss/ssAdTeamAreas/getAllocatedClinic",
    method: "get",
    params: data,
  });
}
// 平台端 查询控销商品一选中的区域
export function querySaleAreaListById(id) {
  return request({
    url: `/sales-rule/plc/plcBagSaleAreas/querySaleAreaList/${id}`,
    method: "get",
  });
}
// 平台端  控销订单对账单
export function orderBbillsPlatformPage(data) {
  return request({
    url: "/statistic/sales/order/bills/platform/page",
    method: "post",
    data: data,
  });
}
// 平台端  控销订单对账单 - 统计
export function orderBbillsPlatformCollect(data) {
  return request({
    url: "/statistic/sales/order/bills/platform/collect",
    method: "post",
    data: data,
  });
}
// 平台端  控销订单对账单 导出
export function orderBbillsPlatformExport(data) {
  return request({
    url: "/statistic/sales/order/bills/platform/export",
    method: "POST",
    data: data,
    responseType: "blob",
  });
}
// 平台设置多控销咨询电话
export function dkcSetContactTel(phone) {
  return request({
    url: `/sales-rule/ss/ssBagAdPlans/dkcSetContactTel/${phone} `,
    method: "POST",
  });
}
// 查询平台设置的多控销咨询电话
export function dkcGetContactTel() {
  return request({
    url: `/sales-rule/ss/ssBagAdPlans/dkcContactTel`,
    method: "GET",
  });
}
// 查询贴敷备案列表
export function getShopWhiteListByPage(data) {
  return request({
    url: "/sales-rule/shopWhiteList/page",
    method: "get",
    params: data,
  });
}
// 关闭开启贴敷权限
export function shopWhiteListOperation(data) {
  return request({
    url: "/sales-rule/shopWhiteList/operation",
    method: "put",
    data: data,
  });
}
// 根据商户名称查询商户
export function searchDrugStoreByName(params) {
  return request({
    url: `/shop/shop/searchDrugStoreByName`,
    method: "get",
    params,
  });
}
// 新增贴敷备案
export function addShopWhiteList(data) {
  return request({
    url: "/sales-rule/shopWhiteList/filing",
    method: "post",
    data,
  });
}
